import { template as template_d9b693f7b92f46e6a18b9e4fdc3e2332 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './insurance-section.module.scss';
import t from 'ember-intl/helpers/t';
export default class SiteDocumentsContactInfoChannelCoverageBanner extends Component {
    get remainingSessionsCount() {
        return this.args.channelClientInfo?.remainingSessionsCount;
    }
    get channelName() {
        return this.args.channelClientInfo?.globalMonarchChannel?.displayName;
    }
    static{
        template_d9b693f7b92f46e6a18b9e4fdc3e2332(`
    <div class={{styles.component}}>
      <div class="channel-covered">
        <div class="text">
          {{t
            "site.documents.contactInfo.insuranceSection.channelCoverage"
            count=this.remainingSessionsCount
            channelName=this.channelName
          }}
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
